var TransportDocumentExportFormatter = {
    transportDocumentToRows: function(transportDocument, job) {
        var headerRow = [];
        var dataRow = [];

        var dispatcher = transportDocument.get('dispatcher');
        var transporter = transportDocument.get('transporter');
        var recipient = transportDocument.get('recipient');

        // uppdragsnummer
        headerRow.push(i18next.t('transportDocument_excelExport_header_jobNo'));
        dataRow.push(transportDocument.get('jobNo') || '');
        // fakturanummer
        headerRow.push(i18next.t('transportDocument_excelExport_header_invoiceNo'));
        dataRow.push('');
        // kundnummer
        headerRow.push(i18next.t('transportDocument_excelExport_header_customerNo'));
        dataRow.push(job.customerNo ? job.customerNo : (job.customerNoText ? job.customerNoText : ''));
        // namn (beställare/kund)
        headerRow.push(i18next.t('transportDocument_excelExport_header_customerName'));
        dataRow.push(job.customerName || '');
        // adress (beställare/kund)
        headerRow.push(i18next.t('transportDocument_excelExport_header_customerAddress'));
        dataRow.push(dispatcher.address || '');
        // antal kollin (st)
        headerRow.push(i18next.t('transportDocument_excelExport_header_numberOfWasteItems'));
        dataRow.push(transportDocument.get('wasteItems').length || '');
        // avfallstyp (avfallskod)
        headerRow.push(i18next.t('transportDocument_excelExport_header_wasteItem_articleEwc'));
        dataRow.push(transportDocument.get('wasteItems')[0].articleEwc || '');
        // avfallets vikt (kilogram)
        // OM ANNAT ÄN KG DÅ?
        headerRow.push(i18next.t('transportDocument_excelExport_header_wasteItem_amount'));
        dataRow.push(transportDocument.get('wasteItems')[0].amount || '');
        // avfallets enhet
        headerRow.push(i18next.t('transportDocument_excelExport_header_wasteItem_articleUnit'));
        var unit = transportDocument.get('wasteItems')[0].unit;
        dataRow.push(unit ? i18next.t('unit_' + unit.toLowerCase()) : '');
        // från vem avfallet ska transporteras (org-nummer)
        headerRow.push(i18next.t('transportDocument_excelExport_header_dispatcher_orgNo'));
        dataRow.push(dispatcher.orgNo || '');
        // från vilken plats avfallet ska transporteras (adress)
        headerRow.push(i18next.t('transportDocument_excelExport_header_dispatcher_address'));
        dataRow.push(dispatcher.address || '');
        // till vem avfallet ska transporteras (org-nummer)
        headerRow.push(i18next.t('transportDocument_excelExport_header_recipient_orgNo'));
        dataRow.push(recipient.orgNo || '');
        // till vilken plats avfallet ska transporteras (adress)
        headerRow.push(i18next.t('transportDocument_excelExport_header_recipient_address'));
        dataRow.push(recipient.address || '');
        // datum då transporten påbörjas
        headerRow.push(i18next.t('transportDocument_excelExport_header_startDate'));
        dataRow.push(job.startTime ? Formatting.date(job.startTime, null, true) : '');
        // transportsätt (vägtransport)
        headerRow.push(i18next.t('transportDocument_excelExport_header_transportType'));
        dataRow.push(i18next.t('transportDocument_excelExport_header_transportType_road'));

        var WASTE_ITEM_COLUMN_START_INDEX = 6;
        var returner = [[headerRow, dataRow]];
        if (transportDocument.get('wasteItems').length > 1) {
            for (var i = 1; i < transportDocument.get('wasteItems').length; i++) {
                var wasteItem = transportDocument.get('wasteItems')[i];
                var newRow = [];

                for (var j = 0; j < WASTE_ITEM_COLUMN_START_INDEX; j++)
                    newRow.push('');

                newRow.push(wasteItem.articleEwc || '');
                newRow.push(wasteItem.amount || '');
                var unit = wasteItem.unit;
                newRow.push(unit ? i18next.t('unit_' + unit.toLowerCase()) : '');
                returner.push([headerRow, newRow]);
            }
        }

        return returner;
    },

    addExtraWasteItemRows: function(rows, wasteItems) {
        
    }
}